/* ARRAY - first-order 10% sign-up. See sections/beyondads-first-order.liquid.
   On submit: a 6-character token goes into the form's tags (array-f10-TOKEN) and into localStorage
   (array_first10 = {c:"FIRST-TOKEN", e:email, t:time}). Shopify Flow turns the tag into the real code
   for new customers only. After the post (?customer_posted=true) the stored code is shown. */
(function () {
  'use strict';
  var KEY = 'array_first10';
  var ABC = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

  function token() {
    var out = '', r = null;
    try { r = window.crypto.getRandomValues(new Uint32Array(6)); } catch (e) {}
    for (var i = 0; i < 6; i++) out += ABC[(r ? r[i] : Math.floor(Math.random() * 1e9)) % ABC.length];
    return out;
  }
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  function init(root) {
    if (root.__fo) return;
    root.__fo = true;
    var form = root.querySelector('form');
    var tags = root.querySelector('[data-fo-tags]');
    var wrap = root.querySelector('[data-fo-form]');
    var done = root.querySelector('[data-fo-done]');

    if (form && tags) {
      form.addEventListener('submit', function () {
        var t = token();
        var em = (form.querySelector('input[type="email"]') || {}).value || '';
        tags.value = 'array-first10,array-f10-' + t;
        write({ c: 'FIRST-' + t, e: em.trim(), t: Date.now() });
      });
    }

    var posted = !!root.querySelector('[data-fo-ok]') || /[?&]customer_posted=true/.test(location.search);
    var v = read();
    if (!posted || !v || !v.c || Date.now() - (v.t || 0) > 6 * 3600e3) return;

    wrap.hidden = true;
    done.hidden = false;
    root.querySelector('[data-fo-code]').textContent = v.c;
    root.querySelector('[data-fo-email]').textContent = v.e || 'your email';
    var shop = root.querySelector('[data-fo-shop]');
    if (shop) shop.href = '/discount/' + encodeURIComponent(v.c) + '?redirect=' + encodeURIComponent('/collections/all');

    var copy = root.querySelector('[data-fo-copy]');
    if (copy) copy.addEventListener('click', function () {
      function ok() { copy.textContent = 'Copied'; copy.classList.add('is-done'); setTimeout(function () { copy.textContent = 'Copy'; copy.classList.remove('is-done'); }, 2000); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v.c).then(ok, fallback); else fallback();
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = v.c; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, 99);
        try { document.execCommand('copy'); ok(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-fo]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
